export default (element: HTMLElement) => {
  const searchInput = element.querySelector<HTMLInputElement>(
    '[data-component-role="search-input"]',
  );
  const membersList = element.querySelector<HTMLDivElement>(
    '[data-component-role="members-list"]',
  );
  const checkboxes = element.querySelectorAll<HTMLInputElement>(
    '[data-member-checkbox]',
  );
  const form = element.closest('form');
  const hiddenInput = form?.querySelector<HTMLInputElement>(
    '[name="additional_person_ids"]',
  );

  if (!searchInput || !membersList || !form || !hiddenInput) {
    console.error('Missing component roles in unitMemberPicker component');
    return;
  }

  // Track selected person IDs
  const selectedPersonIds = new Set<number>();

  // Initialize selected IDs from checkboxes that are checked
  checkboxes.forEach((checkbox) => {
    if (checkbox.checked) {
      const personId = parseInt(checkbox.value, 10);
      if (!Number.isNaN(personId)) {
        selectedPersonIds.add(personId);
      }
    }
  });

  // Update hidden input with selected IDs
  const updateHiddenInput = () => {
    const idsArray = Array.from(selectedPersonIds);
    hiddenInput.value = JSON.stringify(idsArray);
  };

  // Handle checkbox changes
  checkboxes.forEach((checkbox) => {
    checkbox.addEventListener('change', () => {
      const personId = parseInt(checkbox.value, 10);
      if (!Number.isNaN(personId)) {
        if (checkbox.checked) {
          selectedPersonIds.add(personId);
        } else {
          selectedPersonIds.delete(personId);
        }
        updateHiddenInput();
      }
    });
  });

  // Implement fulltext search
  searchInput.addEventListener('input', () => {
    const query = searchInput.value.toLowerCase().trim();
    const memberItems =
      membersList.querySelectorAll<HTMLDivElement>('[data-member-item]');

    memberItems.forEach((item) => {
      const text = item.textContent?.toLowerCase() || '';
      if (query === '' || text.includes(query)) {
        item.classList.remove('peoplePicker__item--hidden');
      } else {
        item.classList.add('peoplePicker__item--hidden');
      }
    });
  });

  // Before form submit, ensure hidden input is updated
  form.addEventListener('submit', () => {
    updateHiddenInput();
  });
};
